import { render, staticRenderFns } from "./DraggableComponent.vue?vue&type=template&id=28fb2e27&"
import script from "./DraggableComponent.vue?vue&type=script&lang=js&"
export * from "./DraggableComponent.vue?vue&type=script&lang=js&"
import style0 from "./DraggableComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports